<template>
  <div class="w3-main main-container">

    <page-header />

    <div class="w3-container about-container">
      <h1 class="w3-xxxlarge"><b>{{ $t('References') }}</b></h1>

      <hr class="w3-round">

      <gallery
        :images="galleryImages"
        :index="galleryIndex"
        @close="galleryIndex = null"
        :options="{ displayClass: 'blueimp-gallery-display-fix' }"
      />

      <router-link
        v-if="folderId"
        to="/referenciak"
      >
        <button
          class="w3-button w3-block w3-padding-large w3-pink w3-margin-bottom"
        >
          {{ $t('Back to references') }}
        </button>
      </router-link>

      <div class="items-images-container">
        <reference-item
          v-for="item in folder.filter(({ isFolder }) => isFolder)"
          :key="item.id"
          :item="item"
          :gApiKey="gApiKey"
          @error="handleError"
        />
      </div>

      <div class="items-images-container">
        <reference-item
          v-for="(item, index) in folder.filter(({ isFolder }) => !isFolder)"
          :key="item.id"
          :item="item"
          :gApiKey="gApiKey"
          @click="galleryIndex = index"
          @error="handleError"
        />
      </div>

      <router-link
        v-if="folderId"
        to="/referenciak"
      >
        <button
          class="w3-button w3-block w3-padding-large w3-pink w3-margin-bottom"
        >
          {{ $t('Back to references') }}
        </button>
      </router-link>
    </div>
  </div>
</template>

<i18n>
  {
    "de": {
      "References": "Referenzen",
      "Back to references": "Zurück zu Referenzen"
    },
    "en": {
      "References": "References",
      "Back to references": "Back to references"
    },
    "hu": {
      "References": "Referenciák",
      "Back to references": "Vissza a referenciákhoz"
    }
  }
</i18n>

<script>
  import Gallery from 'vue-gallery';
  import * as Sentry from '@sentry/browser';
  import PageHeader from '@/components/PageHeader';
  import ReferenceItem from '@/components/ReferenceItem';

  export default {
    name: 'items',
    data() {
      return {
        gApiKey: 'AIzaSyDtFZ6BFhbaFb8pwb3At8YO2FzDbrEhWYE',
        rootFolderId: '1G-WEN5baPtKlgkPYofofBQ6imweo0LFw',
        folder: [],
        galleryIndex: null,
      };
    },
    async created() {
      document.title = 'Referenciák | BeCreative';
    },
    mounted() {
      scrollTo(0, 0);
    },
    computed: {
      locale() {
        return this.$store.state.i18n.locale;
      },
      folderId() {
        return this.$route.params._id;
      },
      galleryImages() {
        return this.folder
          .filter(({ isFolder }) => !isFolder)
          .map(({ id }) => `https://www.googleapis.com/drive/v3/files/${id}?alt=media&key=${this.gApiKey}`);
      },
    },
    watch: {
      '$route.params._id': {
        immediate: true,
        async handler(value) {
          try {
            const folderId = value || this.rootFolderId;

            this.folder = [];

            const data = await this.getFolder(folderId);

            this.folder =
              data.files
              .filter(({ mimeType }) => ['application/vnd.google-apps.folder', 'image/jpeg'].includes(mimeType))
              .map(({ id, name, mimeType }) => ({ id, name, isFolder: mimeType === 'application/vnd.google-apps.folder' }));
          } catch (error) {
            this.handleError(error);
          }
        },
      },
    },
    methods: {
      async getFolder(folderId) {
        const response = await fetch(`https://www.googleapis.com/drive/v3/files/?q='${folderId}'+in+parents&key=${this.gApiKey}`);

        return response.json();
      },
      handleError(error) {
        const isProduction = process.env.NODE_ENV === 'production';

        if (!isProduction) {
          /* eslint-disable */
          console.error(error);
          /* eslint-enable */
        }

        Sentry.captureException(error);
      },
    },
    components: {
      Gallery,
      PageHeader,
      ReferenceItem,
    },
  };

</script>

<style scoped>
  hr {
    width: 50px;
    border: 5px solid;
    color: #eb2e4a !important;
    margin-top: 0px;
  }

  a {
    text-decoration: none;
  }

  button {
    background-color: #eb2e4a !important;
  }

  .about-container {
    margin-top: 75px;
    max-width: 1000px;
  }

  .items-images-container {
    max-width: 1000px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  @media (max-width: 1100px) {
    .items-images-container {
      justify-content: center;
    }
  }

</style>



// WEBPACK FOOTER //
// References.vue?32b49135